import { Box,Button,Flex,Select,InputGroup,
  InputLeftElement,Input, Heading, Text, 
  TableContainer,Table,Thead,Tbody,Th,Tr,Td, GridItem, Textarea } from "@chakra-ui/react";
import { TopDisplay } from "../../../components";
import { LuSearch as SearchIcon } from "react-icons/lu";
import { useState ,useEffect,useMemo} from "react";
import styled from "@emotion/styled";
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { MdOutlinePublish  as ApprovalIcon} from "react-icons/md";
import { MdMoreVert as MoreIcon } from "react-icons/md";
import { BatchPublish } from "./Modal";
import apiCall from '../../../utils/apiCall';
import {
  Grid,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  PopoverArrow,
} from '@chakra-ui/react'
import {useAtom,atom} from 'jotai'
import { modalAtom, openAtom, notificationAtom, openNAtom } from "../../../context";
import { Loader } from "../../../customs";
import { TbReload as ReloadIcon } from "react-icons/tb";
import ReactPaginate from 'react-paginate';
import { format } from "date-fns";
import moment from "moment";


const indexAtom = atom<number | null>(null);
const list = [
  {
    StudentId:Math.floor(Math.random() * 10000)+1,
    FirstName:'Abey',
    LastName:'Adesola',
    OldEmail:'Abey.Adesola@gmail.com',
    NewEmail:"Osakpolo@gmail.com",
    Reason:"Not working",
    DateRequested:"01-03-2024",
    Status:"Pending",
  },
  {
    StudentId:Math.floor(Math.random() * 10000)+1,
    FirstName:'Abey',
    LastName:'Adesola',
    OldEmail:'Abey.Adesola@gmail.com',
    NewEmail:"Osakpolo@gmail.com",
    Reason:"Not working",
    DateRequested:"01-03-2024",
    Status:"Pending",
  },
  {
    StudentId:Math.floor(Math.random() * 10000)+1,
    FirstName:'Abey',
    LastName:'Adesola',
    OldEmail:'Abey.Adesola@gmail.com',
    NewEmail:"Osakpolo@gmail.com",
    Reason:"Not working",
    DateRequested:"01-03-2024",
    Status:"Pending",
  },
  {
    StudentId:Math.floor(Math.random() * 10000)+1,
    FirstName:'Abey',
    LastName:'Adesola',
    OldEmail:'Abey.Adesola@gmail.com',
    NewEmail:"Osakpolo@gmail.com",
    Reason:"Not working",
    DateRequested:"01-03-2024",
    Status:"Pending",
  },
  {
    StudentId:Math.floor(Math.random() * 10000)+1,
    FirstName:'Abey',
    LastName:'Adesola',
    OldEmail:'Abey.Adesola@gmail.com',
    NewEmail:"Osakpolo@gmail.com",
    Reason:"Not working",
    DateRequested:"01-03-2024",
    Status:"Pending",
  },
]

const HeadStyle={
  borderBottom:"1px solid var(--dark-green-color)",
  padding:'15px 5px',
}
const DataStyle = {
  padding:'5px 5px',
  thcolor:'var(--dark-green-color)'
}


const ROWSTYLE = styled.tr`
  & > td:last-of-type{
    width:50px;
    height:63px;
    & > div{
      display:none;
    }
  }
  &:hover > *{
    cursor: pointer;
    background-color:var(--table-highlight);
  } 
  & > td{
    width:140px;
  }
  &:hover > td:last-of-type{
    
    & > div{
      display: block;
    }
  }
  & > td > div.active{
    display: block;
  }
`

export default function Publish() {
  const [hide,set_hide] = useState<boolean>(true);
  const [activeIndex] = useAtom(indexAtom);
  const [,set_open] = useAtom(openAtom);
  const [,set_modal] = useAtom(modalAtom);
  
  const [selected_period,set_selected_period] = useState<null | string>(null);
  const [selected_subject,set_selected_subject] = useState<null | string>(null);
  let  {data,isLoading:l}:{data:any;isLoading:boolean} = useQuery<any>([''],{
    queryFn: async ()=> await Promise.allSettled([apiCall().get('/exam/setup/examPeriod'),apiCall().get('/exam/setup/examSubject')
    ]),
  
    select(data:any){
      //console.log(data,'data')
      return data
    }
  })
  let  {data:data1,isLoading}:{data:any;isLoading:boolean} = useQuery<any>([selected_period],{
    queryFn: async ()=> await apiCall().get(`/Exam/reviewedNotPublishedSubjects?examPeriodId=${selected_period}`),
    enabled:Boolean(selected_period),
    select(data:any){
      // console.log(data,'data')
      return data.data.Data;
    }
  })


  const all_periods:any = !data?[]:data[0]?.value?.data.Data;
  const all_subjects:any = !data?.length?[]:data[1]?.value?.data.Data;
  const all_request:any = data1 && data1.length > 0 ? data1?.map((e:any) => ({...e,Id:Math.floor(Math.random() * 1000 +1)})) : [];
 
  //console.log(all_request,'request')

  const [search,set_search] = useState('');

  const [filter_data,set_filter_data] = useState<any>(all_request);

  const showBatchPublish = () =>{
    set_modal({
      header:'Batch Publish Results',
      content:<BatchPublish/>
    })
    set_open(true);
  }

  const handleSearch = (e:any)=>{
    let val = e.target.value;
    set_search(val);
    if(val){
      let new_data = filter_data?.filter((eData:any) => Object.values(eData).join('').toLowerCase().includes(val.toLowerCase()) );
      if(new_data.length > 0)set_filter_data(new_data)
      else set_filter_data(all_request)
    }
    else set_filter_data(all_request)
  }

  /* Pagination part */
  const itemsPerPage = 10;
  const [itemOffset, setItemOffset] = useState(0);
  const endOffset = itemOffset + itemsPerPage;
  //console.log(`Loading items from ${itemOffset} to ${endOffset}`);
  const currentItems = filter_data?.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(filter_data?.length / itemsPerPage);

  const handlePageClick = (event:any) => {
    const newOffset = (event.selected * itemsPerPage) % filter_data?.length;
    console.log(
      `User requested page number ${event.selected}, which is offset ${newOffset}`
    );
    setItemOffset(newOffset);
  };

  /* End pagination part */ 

  useEffect(()=>{
    if(selected_period){
      let data = all_request.filter((eData:any) => eData.ExamPeriodId == selected_period);
     
      set_filter_data(data);
      
    }
    else{
      set_filter_data(all_request);
    }
  },[selected_period])
  useEffect(()=>{
    if(selected_subject){
      let data = all_request.filter((eData:any) => eData.ExamSubjectId == selected_subject);
 
      set_filter_data(data);
      
      
    }
    else{
      set_filter_data(all_request);
    }
  },[selected_subject])

  useEffect(()=>{
  // console.log(all_request)
   set_filter_data(data1?data1?.map((e:any) => ({...e,Id:Math.floor(Math.random() * 1000 +1)})) : [])
    //console.log(selected_period,'period')
   
  },[selected_period,data1])

  return (
    <> 
    {isLoading || l?<Loader />:
    <Box>
      <TopDisplay label="Publish Results" button_array={[
          <Button  bg="var(--dark-green-color)" color="var(--white-color)"  leftIcon={<ApprovalIcon/>}     variant="outline"
            colorScheme="var(--dark-green-color)"
            onClick={showBatchPublish}
          >Batch Publish Results</Button>,
          // <UploadButton label="Upload Candidates" />
        ]} />
        <Flex  gap="20px" wrap="wrap" mt="20px">
          {/* <InputGroup h="40px" width="250px" bg="var(--white-color)" borderColor="var(--dark-green-color)" pos="relative">
            <InputLeftElement pointerEvents='none'>
              <SearchIcon color='gray.300' />
            </InputLeftElement>
            <Input value={search} onChange={handleSearch} type='text' placeholder='search' />
            <span style={{position:'absolute',zIndex:'1',
            right:'10px',cursor:'pointer',top:'12px'}}><ReloadIcon /></span>
          </InputGroup> */}
          <Select placeholder="Exam Period" width="150px" bg="var(--white-color)" 
            borderColor="var(dark-green-color)" onChange={(e:any)=>set_selected_period(e.target.value)}>
              {all_periods?.length > 0 ? all_periods.map((e:any) =><option key={e?.Id} value={e?.Id}>{e?.ExamName}</option>):<></>}
          </Select>
          <Select placeholder="Exam Subject" width="150px" bg="var(--white-color)" 
            borderColor="var(dark-green-color)" onChange={(e:any)=>set_selected_subject(e.target.value)}>
              {all_subjects?.length > 0 ? all_subjects.map((e:any) =><option key={e?.Id} value={e?.Id}>{e?.Name}</option>):<></>}
          </Select>

        </Flex>
        <Flex mt="25px" flexDir="column" gap="10px">
          <Heading m="0" fontSize="1rem">All Pending Result Subjects Publish</Heading>
          <Text m="0" fontSize=".8rem">Showing {itemOffset} - {itemOffset + itemsPerPage > filter_data?.length?filter_data?.length:endOffset} of {filter_data?.length}</Text>
        </Flex>
     {  filter_data && filter_data.length > 0 ? <TableContainer mt="20px">
          <Table size='sm'>
            <Thead>
              <Tr >
                <Th sx={HeadStyle}>Exam Period</Th>
                <Th sx={HeadStyle}>Exam Subject</Th>
                <Th sx={HeadStyle}>Date Reviewed</Th>
                {/* <Th sx={HeadStyle}>Date Published</Th> */}
                <Th sx={HeadStyle} w="50px"></Th>
              </Tr>
            </Thead>
            <Tbody>
              {currentItems.map((eCandidate:any,index:number) =><ROWSTYLE key={eCandidate.Id}>
                <Td sx={DataStyle}>{eCandidate?.ExamPeriod}</Td>
                {/* <Td sx={DataStyle}>{eCandidate.FirstName}</Td> */}
                <Td sx={DataStyle}>{eCandidate?.ExamSubject}</Td>
                <Td sx={DataStyle}>{format(new Date(eCandidate.DateReviewed), "dd/MM/yyyy")}</Td>
                {/* <Td sx={DataStyle}>{moment(eCandidate.DatePublished).format("dd/MM/yyyy")||'N/a'}</Td> */}
                {/* <Td sx={DataStyle}>{format(new Date(eCandidate.DatePublished), "dd/MM/yyyy")}</Td> */}
                <Td sx={DataStyle} minW="60px" w="50px" h="50px">
                    <div className={activeIndex === index?'active':''}><Option {...{index,candidate:eCandidate}}/></div>
                </Td>
              </ROWSTYLE>
              )}
            </Tbody>
          </Table>
        </TableContainer>
        :'No Result to publish'  
      }
      <StylePaginateBox>
        <ReactPaginate
          breakLabel="..."
          nextLabel=">"
          onPageChange={handlePageClick}
          pageRangeDisplayed={5}
          pageCount={pageCount}
          previousLabel="<"
          renderOnZeroPageCount={null}
        />

      </StylePaginateBox>
     
    </Box>
}
    </>
   

  )
}

const StylePaginateBox = styled.div`
  width:100%;
  & > ul{
    list-style-type: none;
    text-align:center;
    padding:0;
    margin:0;
    margin-top:10px;
  } 
  & > ul > li{
    display: inline;
    margin:0 5px;
    padding:2px 5px;
    border-radius: 3px;
    background-color: transparent;
    color:var(--dark-green-color);
  }
  & > ul > li.selected{
    background-color: var(--highlight-paginate-background);
    color:var(--highlight-paginate-color);
  }
  & > ul > li:first-of-type,
  & > ul > li:last-of-type{
    font-weight: bold;
  }
`

const sx={
  ':hover':{
    bg:'var(--content-background)'
  }
}

const Option = (props:any)=>{
  const index = props.index;
  const candidate= props.candidate;
  const [ind,set_index] = useAtom(indexAtom);
  const [,set_open] = useAtom(openAtom);
  const [,set_modal] = useAtom(modalAtom)
  const onClick=()=>{
    if(index === ind){
      set_index(null);
      return;
    }
    set_index(index);
  }
  const handleShowProfile = () =>{
    set_index(null);
    set_modal({
      header:'Details',
      content:<ViewProfile candidate={candidate} />
    })
    set_open(true);
  }

  const handleSinglePublish = () =>{
    set_index(null);
    set_modal({
      header:'Publish Result',
      content:<ViewSinglePublish {...candidate} />
    })
    set_open(true);
  }
  useEffect(()=>{
    return ()=>set_index(null)
  },[])
  return(
    <Popover>
    <PopoverTrigger>
      <Button onClick={onClick} bg="var(--cipm-light-green)"><MoreIcon /></Button>
    </PopoverTrigger>
    <PopoverContent width="fit-content">
      <PopoverArrow />
      <PopoverBody>
        <Grid templateColumns="1fr" p="6px">
          <GridItem sx={sx} p="8px 4px" onClick={handleShowProfile}>View Details</GridItem>
          {/* <GridItem sx={sx} p="8px 4px">View Details</GridItem> */}
          <GridItem sx={sx} p="8px 4px" onClick={handleSinglePublish}>Publish</GridItem>
        </Grid>
      </PopoverBody>
    </PopoverContent>
  </Popover>
  )
}

const ViewProfile = (props:any) =>{
  return(
  <Flex flexDir="column" minWidth="600px" gap="50px">
    <Flex align="center" gap="20px">
     
      <Flex gap="20px">
        
        <Text width="150px"  fontWeight="500" color="var(--light-text)">Exam Period</Text>
        <Text> {props.candidate?.ExamPeriod}</Text>
      </Flex>
    </Flex>
    <Grid templateColumns="1fr" templateRows="repeat(3,1fr)" gap="30px">
     
      <GridItem as={Flex} gap="20px">
        <Text width="150px"  fontWeight="500" color="var(--light-text)">Exam Subject</Text>
        <Text fontWeight="500">{props.candidate?.ExamSubject|| 'N/A'}</Text>
      </GridItem>
      <GridItem as={Flex} gap="20px">
        <Text width="150px"  fontWeight="500" color="var(--light-text)">Date Reviewed</Text>
        <Text fontWeight="500">
        {format(new Date(props.candidate.DateReviewed), "dd/MM/yyyy")}
        </Text>
      </GridItem >
      {/* <GridItem as={Flex} gap="20px">
        <Text width="150px"  fontWeight="500" color="var(--light-text)">Date Publish</Text>
        <Text fontWeight="500">
        {format(new Date(props.candidate.DatePublished), "dd/MM/yyyy")}
        </Text>
      </GridItem > */}
    </Grid>
  </Flex>
  )}
  const ViewSinglePublish = (props:any) =>{
    const [,set_open] = useAtom(openAtom);
    const [,set_n_open] = useAtom(openNAtom);
    const [,set_notification] = useAtom(notificationAtom);
    const queryClient = useQueryClient();
    const [Reason,set_reason] = useState(props?.Reason || '');

    // const {isLoading:publishIsLoading,mutate:handlePublish} = useMutation({
    //   mutationKey:['publish-results-request'],
    //   mutationFn: async()=> await apiCall().post(`/Exam/examResultPublish`,[{
    //     ExamSubjectId:props?.ExamSubjectId,
    //     ExamPeriodId:props?.ExamPeriodId
    //   }]),
    //   onSuccess(data:any){
    //     //console.log(data,'data')
    //     set_notification({
    //       type:'success',
    //       message:data.data.Message || 'Result Published Successfully'
    //     });
    //     set_n_open(true);
    //     queryClient.invalidateQueries(['all-publish-request'])
    //   },
    //   onError(error:any){
    //     set_notification({
    //       type:'error',
    //       message:error.data.Message || 'Error Occured'
    //     });
    //     set_n_open(true);
    //   },
    //   onSettled(){
    //     set_open(false);

    //   }
    // })
    const { isLoading: publishIsLoading, mutate: handlePublish } = useMutation({
      mutationFn: async () => {
        const currentDate = new Date();
        const formattedDate = format(currentDate, "dd/MM/yyyy");
    
        //console.log('Publishing result...', props);
    
        const apiCallWithTimeout = new Promise((resolve, reject) => {
          const timeout = setTimeout(() => {
            reject(new Error("Request timed out"));
          }, 10000); // 10-second timeout
    
          apiCall().post(`/Exam/examResultPublish`, [{
            ExamSubjectId: props?.ExamSubjectId,
            ExamPeriodId: props?.ExamPeriodId,
            DatePublished: formattedDate
          }])
          .then(resolve)
          .catch(reject)
          .finally(() => clearTimeout(timeout));
        });
    
        return apiCallWithTimeout;
      },
    
      onMutate: async () => {
        console.log('Optimistic update initiated');
        
        await queryClient.cancelQueries(['all-publish-request']);
    
        const previousData = queryClient.getQueryData(['all-publish-request']);
    
        if (!previousData || !Array.isArray(previousData)) {
          console.warn('Previous data is undefined or not an array.');
          return { previousData: [] }; 
        }
    
        queryClient.setQueryData(['all-publish-request'], (prevData: any) =>
          prevData.map((item: { Id: any }) =>
            item.Id === props.Id
              ? { ...item, DatePublished: format(new Date(), "dd/MM/yyyy") }
              : item
          )
        );
    
        return { previousData };
      },
    
      onSuccess: (data: any) => {
        //console.log("Mutation success!", data);
    
        set_notification({
          type: 'success',
          message: data.data.Message || 'Result Published Successfully',
        });
        set_n_open(true);
    
        queryClient.invalidateQueries(['all-publish-request']);
        
        // Close the modal after success
        set_open(false); // This closes the modal
      },
    
      onError: (error: any, _, context: any) => {
        console.error("Mutation error:", error);
    
        set_notification({
          type: 'error',
          message: error.message || 'Error Occurred',
        });
        set_n_open(true);
    
        // Rollback to previous data if available
        if (context?.previousData) {
          queryClient.setQueryData(['all-publish-request'], context.previousData);
        }
      },
    
      onSettled: () => {
        //console.log("Mutation settled."); // Ensure 
        queryClient.invalidateQueries(['all-publish-request']);
        
        set_open(false); 
      },
    });
    
    return(
    <Flex flexDir="column" minWidth="600px" gap="50px">
      <Flex gap="10px" flexDir="column" >
        <Flex gap="20px">
          <span>Exam Period:</span>
          <Text m="0" fontWeight="600">{props?.ExamPeriod}</Text>
        </Flex>
        <Flex gap="20px">
          <span>Exam Subject</span>
          <Text m="0" fontWeight="600">{props?.ExamSubject}</Text>
        </Flex>
        <Flex gap="40px">
          <span>Date Reviewed</span>
          <Text m="0" fontWeight="600">{format(new Date(props?.DateReviewed), "dd/MM/yyyy")}</Text>
        </Flex>
        
      </Flex >
      <Flex justify="center" align="center" flex="1">
        <Button onClick={()=>handlePublish()} colorScheme="green" width="120px" disabled={publishIsLoading}>{publishIsLoading?'Loading ...':'Publish'}</Button>
      </Flex>
      
    </Flex>
    )}

